import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CreateDeliveryEndpointRequest } from "./CreateDeliveryEndpointRequest";
import { EditDeliveryEndpointRequest } from "./EditDeliveryEndpointRequest";
import { GetDeliveryEndpointsByIntegratorRequest } from "./GetDeliveryEndpointsByIntegratorRequest";
import { GetDeliveryEndpointsByIntegratorResponse } from "./GetDeliveryEndpointsByIntegratorResponse";
import { GetDeliveryEndpointsLookupResponse } from "./GetDeliveryEndpointsLookupResponse";

export const useDeliveryEndpointApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/delivery-endpoints`;

    const { httpGet, httpPost, httpPut } = useAuthorizedFetch();

    const getDeliveryEndpointsLookup = async (): Promise<GetDeliveryEndpointsLookupResponse> => {
        return httpGet<GetDeliveryEndpointsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    const getDeliveryEndpointsByIntegrator = async (
        request: GetDeliveryEndpointsByIntegratorRequest
    ): Promise<GetDeliveryEndpointsByIntegratorResponse> => {
        return httpGet<GetDeliveryEndpointsByIntegratorResponse>(`${baseUrl}/list-by-integrator`, request);
    };

    const createDeliveryEndpoint = async (request: CreateDeliveryEndpointRequest): Promise<CreateEntityResponse> => {
        return httpPost<CreateEntityResponse>(`${baseUrl}/create`, request);
    };

    const updateDeliveryEndpoint = async (request: EditDeliveryEndpointRequest): Promise<void> => {
        return httpPut(`${baseUrl}/update`, request);
    };

    return {
        getDeliveryEndpointsLookup,
        getDeliveryEndpointsByIntegrator,
        createDeliveryEndpoint,
        updateDeliveryEndpoint
    };
};
